export const localStorageKeys = {
    username: 'username',
    theme: 'theme',
    editorPersistedContext: 'editor-persisted-context',
};

export const cookieKeys = {
    token: 'token',
};